// extracted by mini-css-extract-plugin
export default {"getInvolved":"GetInvolved_getInvolved__1-yjT","getInvolved_cardBox":"GetInvolved_getInvolved_cardBox__jtzRy","getInvolved_cardItem":"GetInvolved_getInvolved_cardItem__w8rHB"};